export const INITIAL_TIME = 50;
// Testing modes
export const COMPLETED_PLUS = "COMPLETED_PLUS";
export const COMPLETED_NON_PLUS = "COMPLETED_NON_PLUS";
export const NEW_QUIZ_PLUS = "NEW_QUIZ_PLUS";
export const NEW_QUIZ_NON_PLUS = "NEW_QUIZ_NON_PLUS";
